export default "__VITE_ASSET__3e80b69f__"